<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div style="position: relative">
        <loading-overlay :loading="loading" />
        <div class="d-flex justify-content-between align-items-center">
          <h4>تعليمات استخدام الصفحة</h4>
          <LoaderBtn
            v-can="{ slug: $route.meta.slug, action: 'U' }"
            @click="updateInstrucctions({ id, content })"
            variant="primary"
            :loading="working"
          />
        </div>

        <hr />
        <quill-editor 
          v-model="content"
          :options="editorOption"
          />
        <div class="d-flex mt-2 justify-content-between align-items-center">
          <h4>الفيديو التعليميّ</h4>
          <LoaderBtn
            v-can="{ slug: $route.meta.slug, action: 'U' }"
            @click="updateInstrucctions({ id, video })"
            variant="primary"
            :loading="working"
          />
        </div>
        <hr />
        <b-row>
          <b-col cols="4">
            <form-file-input
              placeholder="اختر ملفاً"
              id="document"
              accept=".mp4"
              v-model="video"
              rules="required"
            />
          </b-col>
        </b-row>
        <hr />
        <div class="d-flex mt-2 justify-content-between align-items-center">
          <h4>إرشادات الحقول</h4>
          <LoaderBtn
            v-can="{ slug: $route.meta.slug, action: 'U' }"
            @click="editHints(editForm)"
            variant="primary"
            :loading="working"
            :disabled="hints.length === 0"
          />
        </div>

        <hr />
        <b-row v-if="hints.length > 0">
          <b-col cols="4" v-for="(field, n) in hints" :key="n">
            <form-input
              :label="field.field_name"
              :value="field.content"
              @input="editForm[field.field_slug] = $event"
            />
          </b-col>
        </b-row>

        <div v-else class="w-100 text-muted text-center">
          لا يوجد إرشادات مخصص للحقول
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BRow, BCol, BCard } from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { mapGetters, mapActions } from "vuex";
import DataTable from "@/components/data-table/index.vue";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import LoaderBtn from "@/components/loader-btn.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import FormInput from "@/components/form-input/index.vue";
import FormFileInput from "@/components/FormFileInput.vue";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    MinistryBreadcrumbs,
    DataTable,
    quillEditor,
    LoaderBtn,
    LoadingOverlay,
    FormInput,
    FormFileInput,
  },

  props: {
    id: Number | String,
  },

  data() {
    return {
      editForm: {},
      mainTitle: "الإرشادات",
      content: "",
      video: null,
      
      editorOption: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
          ]
        }
      },
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "الإرشادات",
          active: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("Ministry/Settings/Instructions", [
      "loading",
      "working",
      "instructions",
      "hints",
    ]),
  },
  methods: {
    ...mapActions("Ministry/Settings/Instructions", [
      "fetchInstructions",
      "fetchHints",
      "editInstructions",
      "editHints",
    ]),
    async updateInstrucctions(payload) {
      await this.editInstructions(payload);
      this.content = this.instructions.content;
      this.video = this.instructions.video;
    },
  },
  async mounted() {
    await this.fetchInstructions(this.id);
    this.content = this.instructions.content;
    this.video = this.instructions.video;
    await this.fetchHints();
  },
};
</script>

<style lang="scss" scoped></style>
